/** ADGS page — GitHub sweep activity plus the live Linear deploy-gate queue. */
import { PageHeader } from '@/components/PageHeader';
import { cn } from '@/lib/utils';
import { useHashTab } from './shared';
import { AdgsSweepsTab } from './AdgsSweepsTab';
import { AdgsTicketsTab } from './AdgsTicketsTab';

type TabId = 'sweeps' | 'tickets';

const TABS: { id: TabId; label: string }[] = [
  { id: 'sweeps', label: 'Sweeps' },
  { id: 'tickets', label: 'Tickets' },
];
const TAB_IDS: TabId[] = TABS.map((tab) => tab.id);

export default function AdgsPage() {
  const [activeTab, setActiveTab] = useHashTab(TAB_IDS);
  return (
    <div className="space-y-4">
      <PageHeader
        title="ADGS: Automated Deploy Gate Sweep"
        subtitle="Sweeps: every firing, what woke it, and which tickets it dispatched. Tickets: deploy-trigger tickets it owns, each with its gate state. Wakes on staging and production deploys, plus a recovery sweep every 3 hours."
      />

      <div className="border-b border-zinc-200 dark:border-zinc-700">
        <nav className="-mb-px flex gap-6">
          {TABS.map((tab) => (
            <button
              key={tab.id}
              type="button"
              onClick={() => setActiveTab(tab.id)}
              className={cn(
                'border-b-2 pb-3 text-sm font-medium transition-colors',
                activeTab === tab.id
                  ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                  : 'border-transparent text-zinc-500 hover:border-zinc-300 hover:text-zinc-700 dark:text-zinc-400 dark:hover:text-zinc-300'
              )}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {activeTab === 'sweeps' && <AdgsSweepsTab />}
      {activeTab === 'tickets' && <AdgsTicketsTab />}
    </div>
  );
}
